import React from "react";
import { Link } from "react-router-dom";

export default function SubscriptionCancelPage() {
  return (
    <main className="min-h-[60vh] flex items-center justify-center py-16" data-testid="subscription-cancel">
      <div className="max-w-lg w-full px-6 text-center">
        <div className="font-display text-2xl mv-green-text">No worries — nothing was charged.</div>
        <p className="mt-3 text-[14.5px]" style={{ color: "var(--mv-ink)" }}>
          You closed the checkout before completing. If you'd like to try again later, the Founding Member option will be here whenever you're ready.
        </p>
        <div className="mt-6 flex flex-wrap gap-3 justify-center">
          <Link to="/" className="btn-gold">Back to Home</Link>
          <Link to="/waiting-list" className="btn-ghost">Join Waiting List</Link>
        </div>
      </div>
    </main>
  );
}
